import { Component } from "@angular/core";
import { XOField } from './xo-field.component';

@Component({
    selector: "xo-field-number",
    templateUrl: "./xo-field-number.component.html"
})
export class XOFieldNumber extends XOField {
}
